
class LinkService {
  getLink() {
    // return 'http://localhost:8081'
    return 'https://api-test.ponnipa.in.th'
    // return 'http://api-thaiherbs.up.ac.th/api/question_objectivetest/getimportlist?name'
  }
}

export default new LinkService();